// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_24-3";
export var dialog = "_24-0";
export var divClassnameSwatch = "_24-8";
export var flexSwatch = "_24-4";
export var header = "_24-1";
export var styleAttributeSwatch = "_24-7";
export var swatch = "_24-2";
export var textHeaderSwatch = "_24-5";
export var webSwatch = "_24-6";